// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__ed1nt","label":"Checkbox_label__nGiq4","input":"Checkbox_input__PPK2M","hide":"Checkbox_hide__dB63k"};